module.exports = __webpack_public_path__ + "images/149_2048.jpg";